import * as React from "react";
import { connect } from "react-redux";
import * as metaReducer from "../reducers/metaReducer";
import { IMeta } from "../reducers/metaReducer";
import IHomeVm from "../models/home/Home/IHomeVm";
import IIdentityProviderRealmVm from "../models/home/Shared/IIdentityProviderRealmVm";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { PrivacyPolicyCertificateProcessTextType } from "./privacyPolicy/components/PrivacyPolicyComponent";
import Select from "../components/DataDisplay/SelectComponent";
import { CertificateType } from "../models/flags/CertificateType";
import i18n from "../i18n/i18n";
import SystemStatusComponent from "../components/SystemStatus/SystemStatusComponent";
import ISystemStatusVm from "../models/home/Home/ISystemStatusVm";
import Button, { IconCaretRight } from "../components/Buttons/ButtonComponent";

interface ILoginProps extends RouteComponentProps<any> {
  realms: IIdentityProviderRealmVm[];
  selectedRealm: IIdentityProviderRealmVm;
}

interface ILoginDispatch {
  onSelectRealm: (realm: IIdentityProviderRealmVm) => void;
}

type AllProps = ILoginProps & ILoginDispatch;

class Login extends React.Component<AllProps> {
  public onSelectRealm(realm: IIdentityProviderRealmVm) {
    this.props.onSelectRealm(realm);
  }

  public onClickNemLogin() {
    window.location.href = process.env.SERVER + "Home/RedirectToUserLandingPage?loginChoice=NemLogin";
  }

  public onClickLoginWithRealm(realm: IIdentityProviderRealmVm) {
    window.location.href = process.env.SERVER + "Home/RedirectToUserLandingPage?loginChoice=Adfs&realmId=" + realm.id;
  }

  public render() {
    document.title = i18n.t("TEXT_WEBSITE_TITLE_LOGIN");

    const { realms, selectedRealm } = this.props;
    const { adfs } = this.props.match.params;

    const showAdfsLogin = adfs === "adfs" ? true : false; // If url contains /#/adfs

    let listOfRealms = realms.map((x: any) => {
      return { key: x.id, value: x.name };
    });
    listOfRealms = [{ key: null, value: "" }, ...listOfRealms];

    const systemStatus = (window as any).systemStatus as ISystemStatusVm;

    return (
      <span>
        <div className="well-green well">
          {!showAdfsLogin && (
            <div>
              <div className="row-fluid">
                <div className="span12">
                  <div className="span6">
                    <h2>Ansøg om bevis</h2>
                    <p>Her kan du ansøge om:</p>
                    <ul>
                      <li>Chaufførkort (førstegangsudstedelse samt fornyelse, ændring eller erstatning af førerkort eller chaufførkort)</li>
                      <li>Erstatningsbevis for chaufføruddannelsesbevis</li>
                      <li>Erstatningsbevis for varebilschaufføruddannelsesbevis</li>
                      <li>Erstatningsbevis for ADR-bevis</li>
                      <li>Erstatningsbevis for specialtransportassistentkort</li>
                    </ul>
                    <strong>Sådan ansøger du</strong>
                    <p>For at ansøge om et af de ovenstående skal du:</p>
                    <ul>
                      <li>logge ind med dit private MitID</li>
                      <li>udfylde ansøgning</li>
                      <li>indsende ansøgning</li>
                    </ul>
                    <strong>Vedrørende førerkort/chaufførkort</strong>
                    <p>
                      Du skal opfylde en række betingelser, før du ansøger om et chaufførkort. Du kan læse mere om betingelserne på{" "}
                      <a href="https://fstyr.dk/erhverv/taxi/taxichauffoerer" target="_blank" rel="noreferrer">
                        https://fstyr.dk/erhverv/taxi/taxichauffoerer
                      </a>
                    </p>
                    <strong>Vedrørende erstatningsbevis for varebilschaufføruddannelse</strong>
                    <p>Du kan ikke ansøge om førstegangsudstedelse eller ændring af dit varebilschaufføruddannelsesbevis. Her skal du i stedet kontakte et uddannelsessted.</p>
                    <p>
                      Du kan finde en oversigt over uddannelsessteder og læse mere om chaufføruddannelsen på{" "}
                      <a href="https://fstyr.dk/erhverv/varebil" target="_blank" rel="noreferrer">
                        https://fstyr.dk/erhverv/varebil
                      </a>
                    </p>
                    <strong>Behandling af persondata</strong>
                    <p>Når du logger ind med dit MitID, oprettes du automatisk som bruger. I den forbindelse indhenter vi oplysninger om dig fra CPR-registret som f.eks. din adresse.</p>
                    <p>
                      Læs mere om hvilke oplysninger, vi indhenter, og hvordan vi behandler dem i{" "}
                      <a href="#" onClick={() => window.open(process.env.SERVER + "#/persondatabeskyttelse/" + PrivacyPolicyCertificateProcessTextType.Default + "/" + CertificateType.NotSet, "newwindow", "width=800, height=1000, resizeable=true, scrollbars")}>
                        Persondatabeskyttelse
                      </a>
                      .
                    </p>
                    <Button style={{ marginBottom: "22px" }} id="nemlogin-citizen" className="btn btn-oim" onClick={() => this.onClickNemLogin()} uiTestAttribute="nemlogin-button-citizen">
                      {i18n.t("Log på ansøger")}
                      <IconCaretRight />
                    </Button>
                  </div>
                  <div className="span6">
                    <h2>Er du uddannelsesmedarbejder?</h2>
                    <p>Du kan oprette og indsende ansøgninger på vegne af kursister.</p>
                    <p>
                      Medarbejdere fra godkendte udbydere af uddannelser af chauffører skal logge ind med MitID medarbejdersignatur. <br />
                      Din medarbejdersignatur skal være tildelt BAT2 rettigheden af din MitID administrator.
                    </p>
                    <p>Færdselsstyrelsen godkender udbydere af uddannelser af chauffører. Beredskabsstyrelsen godkender udbydere af farligt gods uddannelser.</p>
                    <Button id="nemlogin-educational-worker" className="btn btn-oim" onClick={() => this.onClickNemLogin()} uiTestAttribute="nemlogin-button-educational-worker">
                      {i18n.t("Log på uddannelsesmedarbejder")}
                      <IconCaretRight />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showAdfsLogin && (
            <div>
              <div className="row-fluid">
                <Select
                  onChange={(key) =>
                    this.onSelectRealm(
                      realms
                        .filter((x) => {
                          return x.id === key;
                        })
                        .shift()
                    )
                  }
                  label="Vælg ADFS realm"
                  options={listOfRealms}
                  readonly={false}
                  value={!!selectedRealm ? selectedRealm.id : ""}
                  uiTestAttribute=""
                />
              </div>
              <div className="row-fluid">
                <Button className="btn btn-oim" disabled={selectedRealm === undefined} uiTestAttribute="continue-to-adfs-button" onClick={() => this.onClickLoginWithRealm(selectedRealm)}>
                  {i18n.t("Fortsæt til ADFS")}
                  <IconCaretRight />
                </Button>
              </div>
            </div>
          )}
        </div>
        {!!systemStatus && (
          <div className="row-fluid" data-ui-test="system-status">
            <div className="well-blue well">
              <SystemStatusComponent systemStatus={systemStatus} />
            </div>
          </div>
        )}
        <div className="row-fluid">
          <div className="span12">
            <div className="span12">
              <div className="well-blue well">
                <h2>Brug for hjælp?</h2>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("HTML_NEMLOGIN_DESCRIPTION") }}></div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

const mapStateToProps = (state: { home: IHomeVm; meta: IMeta }, ownProps: ILoginProps): ILoginProps => {
  return {
    realms: (window as any).identityProviderRealms,
    selectedRealm: state.meta.selectedRealm,
    history: ownProps.history,
    location: ownProps.location,
    match: ownProps.match,
  };
};

const mapDispatchToProps = (dispatch: any): ILoginDispatch => {
  return {
    onSelectRealm: (realm: IIdentityProviderRealmVm) => {
      dispatch(metaReducer.updateSelectedRealm(realm));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
